import { Box, Tab, Tabs, Badge } from '@mui/material';
import useUserRoles from 'hooks/useUserRoles';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import { changeDashboardParentTabAction } from 'store/actions/dashboardActions';
import { DashboardTabState } from 'types/enums/DashboardTabState';
import { useHistory, useLocation } from 'react-router-dom';
import { resetFilterAction } from 'store/actions/filterActions';

type DashboardTabsProps = {
  currentToAssignCount: number;
};

const DashboardTabs: React.FC<DashboardTabsProps> = ({ currentToAssignCount }: { currentToAssignCount: number }) => {
  // const DashboardTabs: React.FC = ({ currentToAssignCount }: { currentToAssignCount: number }) => {
  const [t] = useTranslation();
  const { dispatch } = useAppState();
  //   const { isPathForProduction, isPathForQuotes, handleManagementTabChange } = useManagementHelper();
  const { state } = useAppState();
  const { search } = useLocation();
  const userRoles = useUserRoles();
  const history = useHistory();
  const parentTab = useSelector((state) => state.dashboard.pageHandler.parentTab);

  useEffect(() => {
    dispatch(resetFilterAction());
    dispatch(changeDashboardParentTabAction(parentTab));
  }, [dispatch, parentTab]);

  //   useEffect(() => {
  //     if (userRoles && !userRoles.isConsultant && !userRoles.isClient) {
  //       const searchParams = new URLSearchParams(search);
  //       const status = searchParams.get('status');
  //       const url = new URL(window.location.href);
  //       if (
  //         parentTab !== OrdersTabParentState.CATALOG &&
  //         (status === DashboardTabState.ON_GOING || status === OrdersTabState.MATERIAL_PRODUCTION) &&
  //         !url.href.includes('material_production')
  //       ) {
  //         history.push(`/${appState.customer?.slug}/orders/production?status=material_production`);
  //       }
  //     }
  //   }, []);

  const parentTabs = useCallback(() => {
    const tabs = [
      {
        label: DashboardTabState.TODO,
        value: DashboardTabState.TODO,
        badge: currentToAssignCount,
      },
      {
        label: DashboardTabState.KPI_METRICS,
        value: DashboardTabState.KPI_METRICS,
      },
    ];

    return tabs;
  }, [userRoles.isMigsoManager]);

  const badgeContent = (tab: {
    label: DashboardTabState;
    value: DashboardTabState;
    disabled?: boolean;
    badge?: number | undefined;
  }) =>
    tab.badge ? (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <span>{t(tab.label)}</span>
        <Badge badgeContent={tab.badge} color="error" sx={{ ml: 2 }} />
      </Box>
    ) : (
      t(tab.label)
    );

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      {parentTab && (
        <Tabs value={parentTab}>
          {parentTabs().map((tab) => (
            <Tab
              label={badgeContent(tab)}
              value={tab.value}
              onClick={() => {
                dispatch(resetFilterAction());
                dispatch(changeDashboardParentTabAction(tab.value));
              }}
            />
          ))}
        </Tabs>
      )}
    </Box>
  );
};

export default DashboardTabs;
